// Libs
import React, { useState, useEffect } from "react";

// Components & Utils
import MenusApi from "../api/Menus";
import { useGlobalValue } from "../utils/GlobalState";
import { setIsLoading, setErrors } from "../utils/Actions";

export default function MenuSelect(props) {
  // State
  const [, dispatch] = useGlobalValue();
  const [menus, setMenus] = useState([]);

  // On Show
  useEffect(() => {
    setIsLoading(true, dispatch);
    MenusApi.getMenuActiveOn(props.date)
      .then(menusFromApi => {
        setMenus(menusFromApi);
        setIsLoading(false, dispatch);
      })
      .catch(apiErrors => {
        setIsLoading(false, dispatch);
        setErrors(apiErrors, dispatch);
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (menus.length === 0) {
    return <>No menus available on {props.date.format("DD/MM/YYYY")}</>;
  }

  return (
    <>
      Select a menu:
      <select
        className="form-control"
        onChange={e => props.onChange(e.target.value)}
      >
        <option value="0">Please Select A Menu</option>
        {menus.map(menu => {
          return (
            <option key={menu.id} value={menu.id}>
              {menu.name}
            </option>
          );
        })}
      </select>
    </>
  );
}
